import { Text, View } from '@react-pdf/renderer'
import moment from 'moment'
import { IInvoiceFr } from '../../../types/invoice-fr'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const PatientInfo = ({ invoiceData }: { invoiceData: IInvoiceFr }) => {
  const { t } = useTranslation()

  return (
    <View style={styles.sectionContainer}>
      <Text style={styles.sectionHeader}>
        {t('sharedDiagnostic.invoice.patientInfo')}
      </Text>
      <View style={styles.divider} />
      <View style={styles.cardContainer}>
        <Text
          style={{
            ...styles.boldText,
            fontSize: 10,
            marginBottom: 5,
            textTransform: 'capitalize',
          }}
        >
          {invoiceData.patientFullName}
        </Text>
        {invoiceData.patientBirthName && (
          <View style={styles.flexRowContainer}>
            <Text style={styles.labelText}>
              {t('sharedDiagnostic.invoice.born')}
            </Text>
            <Text style={styles.valueText}>{invoiceData.patientBirthName}</Text>
          </View>
        )}
        <View style={styles.flexRowContainer}>
          <Text style={styles.labelText}>
            {t('sharedDiagnostic.invoice.dateOfBirth')}
          </Text>
          <Text style={styles.valueText}>
            {moment(invoiceData.patientDateOfBirth).format('DD/MM/YYYY')}
          </Text>
        </View>
        {invoiceData.patientTwinRank && (
          <View style={styles.flexRowContainer}>
            <Text style={styles.labelText}>
              {t('sharedDiagnostic.invoice.twinRank')}
            </Text>
            <Text style={styles.valueText}>{invoiceData.patientTwinRank}</Text>
          </View>
        )}
        {invoiceData.patientSocialSecurityNumber && (
          <View style={styles.flexRowContainer}>
            <Text style={styles.labelText}>
              {t('sharedDiagnostic.invoice.socialSecurityNumber')}
            </Text>
            <Text style={styles.valueText}>
              {invoiceData.patientSocialSecurityNumber}
            </Text>
          </View>
        )}
      </View>
    </View>
  )
}

export default PatientInfo
